import ConsentMessage from './ConsentMessage'

export default ConsentMessage
